module.exports = __webpack_public_path__ + "img/upVipIC.dc98fd29.gif";